import { render, staticRenderFns } from "./ModalInfoMailPreview.vue?vue&type=template&id=f4a6e97e&"
import script from "./ModalInfoMailPreview.vue?vue&type=script&lang=js&"
export * from "./ModalInfoMailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports